import { NavLink } from "react-router-dom";

const TopNavbarMenu = () => (
  <ul className="menu">
    <li>
      <NavLink to="/" end className={({ isActive }) => (isActive ? "navActive" : null)}>
        Home
      </NavLink>
    </li>
    <li>
      <NavLink to="/discover-events" className={({ isActive }) => (isActive ? "navActive" : null)}>
        Events
      </NavLink>
    </li>
    <li>
      <NavLink to="/discover-events#categories" className={({ isActive }) => (isActive ? "navActive" : null)}>
        Categories
      </NavLink>
    </li>
    <li>
      <NavLink to="/invitation-builder" className={({ isActive }) => (isActive ? "navActive" : null)}>
        Invitations
      </NavLink>
    </li>
    <li>
      <NavLink to="/my-tickets" className={({ isActive }) => (isActive ? "navActive" : null)}>
        My Ticket
      </NavLink>
    </li>
  </ul>
);

export default TopNavbarMenu;
